import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { TenantService } from "src/app/services/tenant.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastService } from "src/app/services/toast.service";
import { getRegionBaseUrl } from "src/app/_helpers/region.helper";

export class ImageContainer {
    constructor(
        public src: string,
        public file: File,
        public fileName: string,
    ) {}
}

export interface UploadLogoDialogData {
    id: string;
}

@Component({
  standalone: false,
    selector: "app-upload-logo-dialog",
    templateUrl: "uploadLogoDialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["uploadLogoDialog.component.scss"],
})
export class UploadLogoDialogComponent implements OnInit {
    isFormLoading = false;
    isLoading = false;
    selectedFile: ImageContainer;
    tenantLogoUrl: string;

    constructor(
        public dialogRef: MatDialogRef<UploadLogoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: UploadLogoDialogData,
        private tenantService: TenantService,
        private toastService: ToastService,
    ) {}

    ngOnInit() {
        this.isFormLoading = true;
        this.tenantService.getTenantLogoUrl(this.data.id).subscribe({
            next: (logoUrl) => {
                if (logoUrl) {
                    this.tenantLogoUrl = getRegionBaseUrl() + "/" + logoUrl;
                }
                this.isFormLoading = false;
            },
            error: (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        });
    }

    previewImage(imageInput: any) {
        const file: File = imageInput.files[0];
        const reader = new FileReader();

        reader.addEventListener("load", (event: any) => {
            this.selectedFile = new ImageContainer(
                event.target.result,
                file,
                file.name,
            );
        });

        reader.readAsDataURL(file);
    }

    save() {
        this.isLoading = true;
        this.tenantService
            .uploadLogoImage(this.data.id, this.selectedFile.file)
            .subscribe({
                next: () => {
                    this.toastService.showSuccess(
                        "Tenant logo saved successfully",
                        true,
                    );
                    this.isLoading = false;
                    this.dialogRef.close();
                },
                error: (error) => {
                    this.toastService.showError(error);
                    this.isLoading = false;
                },
            });
    }
}
